import React, { useState, useEffect } from "react";
import "./CustomCarousel.css";

const CustomCarousel = ({ items, autoPlay = false, autoPlayInterval = 5000 }) => {
  const [current, setCurrent] = useState(0);

  const next = () => setCurrent((c) => (c + 1) % items.length);
  const prev = () => setCurrent((c) => (c - 1 + items.length) % items.length);

  useEffect(() => {
    if (!autoPlay) return;
    const interval = setInterval(next, autoPlayInterval);
    return () => clearInterval(interval);
  }, [current, autoPlay, autoPlayInterval]);

  return (
    <div className="carousel-wrapper">
      {/*<button className="carousel-arrow left" onClick={prev}>◀</button>*/}

      <div className="carousel-container">
        {items.map((item, index) => (
          <div
            key={index}
            className={`carousel-item ${index === current ? "active" : "inactive"}`}
          >
            {item}
          </div>
        ))}
      </div>

      {/*<button className="carousel-arrow right" onClick={next}>▶</button>*/}

      {items?.length > 1 ? (
        <div className="carousel-dots">
          {items.map((_, i) => (
            <span
              key={i}
              className={i === current ? "dot active-dot" : "dot"}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default CustomCarousel;
